module.exports = __webpack_public_path__ + "img/服务5.214dea38.png";